import React from "react";
import Modal from "../../Components/Base/Modal";
import { SelectInput } from "../../Components";
import Unlock from "./Unlock";
const selectLanguageList = [{ id: "English", value: "English" }];
export default function ModalLanguage(props) {
  const changeSelectedLanguage = (item) => {
    props.setSelectedLanguage(item.value)
  }
  return (
    <Modal addClass="modalCamp" close={props.close}>
      <div className="filterModal modal__camp">
        {props.isUserHasSubscription ?
          <div className="modal__assetDetail-delete perm long">
            <h4>Language</h4>
            <div className="dropdown-item age-select">
              <SelectInput
                selected={selectLanguageList.filter(item => item.value === props.selectedLanguage)[0]}
                onChange={changeSelectedLanguage}
                list={selectLanguageList}
                value={props.selectedLanguage}
              />
            </div>
            <div className="breakLine">
              <div className="campaignsCreate__btns filterbuttons">
                <div class="campaignsCreate__btns-row"><button className="clearButton" onClick={() => props.setSelectedLanguage('')}>Clear</button></div>
                <button className="button primary" onClick={props.handleSearch}>
                  Save
                </button>
              </div></div>
          </div> :
          <Unlock onSaveCamp={props.close}></Unlock>
        }
      </div>
    </Modal>
  );
}
